/** Client-side checks aligned with backend-node validation (Zod). */

const EMAIL_RE =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

const PASSWORD_MIN = 8;
const PASSWORD_MAX = 128;

export function normalizeEmail(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function isValidEmail(value) {
  const email = normalizeEmail(value);
  if (!email || email.length > 254) return false;
  return EMAIL_RE.test(email);
}

export function getEmailError(value) {
  const email = normalizeEmail(value);
  if (!email) return "Email is required";
  if (!isValidEmail(value)) return "Enter a valid email address";
  return null;
}

export function getPasswordChecks(password) {
  const p = String(password ?? "");
  return [
    { key: "length", label: `At least ${PASSWORD_MIN} characters`, ok: p.length >= PASSWORD_MIN },
    { key: "max", label: `No more than ${PASSWORD_MAX} characters`, ok: p.length <= PASSWORD_MAX },
  ];
}

export function isValidPassword(password) {
  const p = String(password ?? "");
  return p.length >= PASSWORD_MIN && p.length <= PASSWORD_MAX;
}

export function getPasswordError(password) {
  const p = String(password ?? "");
  if (!p) return "Password is required";
  if (p.length < PASSWORD_MIN) return `Password must be at least ${PASSWORD_MIN} characters`;
  if (p.length > PASSWORD_MAX) return `Password must be at most ${PASSWORD_MAX} characters`;
  return null;
}

export function getRequiredError(value, label) {
  if (!String(value ?? "").trim()) return `${label} is required`;
  return null;
}
